import { useContext } from 'react';
import { OrgConfigContext } from '@/contexts/OrgConfigContext';

export function useOrgConfig() {
  const ctx = useContext(OrgConfigContext);
  if (!ctx) {
    throw new Error('useOrgConfig must be used within an OrgConfigProvider');
  }
  return ctx;
}
